/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeatures } from '../actions/FeatureActions';
import { PENDING } from '../actions/constants/RequestStatus';
import { fetchFeaturesStatus, hasFeaturesForProductLineAndHighlightsSelector } from '../selectors/FeatureSelectors';
export const useFeatureStore = ({
  highlightedProducts,
  productLine
}) => {
  const dispatch = useDispatch();
  const hasFeaturesForProductLine = useSelector(state => {
    return hasFeaturesForProductLineAndHighlightsSelector(state, {
      productLine,
      highlightedProducts
    });
  });
  const requestStatus = useSelector(fetchFeaturesStatus);
  useEffect(() => {
    if (!highlightedProducts.length || requestStatus === PENDING || hasFeaturesForProductLine) {
      return;
    }

    if (!hasFeaturesForProductLine) {
      dispatch(fetchFeatures({
        highlightedProducts,
        productLine
      }));
    }
  }, [productLine, highlightedProducts]);
};